import { jsxs as i, Fragment as v, jsx as l } from "react/jsx-runtime";
import { forwardRef as R } from "react";
import { p as w } from "../../index-D-yg0idA.mjs";
import { AnchorTag as x } from "../AnchorTag/AnchorTag.js";
import { ButtonAnchor as c } from "../ButtonAnchor/ButtonAnchor.js";
import { ResponsiveImage as k } from "../ResponsiveImage/ResponsiveImage.js";
import { classes as a } from "../../utils/helpers.js";
const G = R(function({
  image: m = { url: "", altText: "", aspectRatio: 1, sources: [] },
  mobileImage: t = { url: "", altText: "", aspectRatio: 1 },
  fullSizeImagePosition: M = [50, 50],
  mobileImagePosition: P = [50, 50],
  lazyLoad: g = !0,
  fetchPriority: f = null,
  decoding: _ = "async",
  title: y = "",
  content: n = "",
  clampContentLines: A = !0,
  numberOfLinesToClamp: B = 3,
  overlayContent: p = "",
  overlayPosition: z = "left",
  overlayTextColor: L = "#fff",
  relatedResourceId: S = "",
  cta: e = {
    label: "",
    href: "",
    type: "",
    relatedResourceId: "",
    position: "end"
  },
  displayCTA: d = !0,
  handleClicks: N = () => {
  },
  fullCardClickable: h = !1,
  displayInline: V = !1,
  classname: j = "",
  styles: o = {}
}, O) {
  var b;
  const T = /* @__PURE__ */ new Map([
    ["play-video", {
      label: "View Promo",
      component: c
    }],
    ["internal-link", {
      label: "View More",
      component: x
    }],
    ["external-link", {
      label: "Learn More",
      component: x
    }],
    ["info-panel", {
      label: "View More",
      component: c
    }],
    ["show-modal", {
      label: "See More",
      component: c
    }]
  ]), I = (b = T.get(e.type)) == null ? void 0 : b.component, u = (r) => /* @__PURE__ */ l(
    I,
    {
      classname: a([o["image-card__cta"], "image-card__cta"]),
      href: r.href,
      label: r.label ? r.label : T.get(r.type).label,
      onClick: r.type !== "internal-link" && r.type !== "external-link" ? s : () => !0,
      "data-resource-id": r.relatedResourceId,
      type: r.type
    }
  ), s = (r) => {
    r.stopPropagation(), N({
      type: e.type,
      resourceId: e.relatedResourceId,
      resourceType: e.relatedResourceType,
      target: r.target,
      currentTarget: r.currentTarget
    });
  };
  return /* @__PURE__ */ i(v, { children: [
    /* @__PURE__ */ i("div", { className: a([o["image-card__img-wrapper"], "image-card__img-wrapper"]), children: [
      t.url !== "" && /* @__PURE__ */ l(
        "img",
        {
          className: o["image-card__mobile-image"],
          src: t.url,
          alt: t.altText,
          onClick: (e.type === "play-video" || e.type === "show-modal") && !h ? s : () => !0,
          loading: g ? "lazy" : null,
          fetchpriority: f,
          decoding: _
        }
      ),
      /* @__PURE__ */ l(
        k,
        {
          classname: o["image-card__image"],
          sources: m.sources,
          fullSizeUrl: m.url,
          altText: m.altText,
          loading: g ? "lazy" : null,
          fetchpriority: f,
          decoding: _,
          handleClick: (e.type === "play-video" || e.type === "show-modal") && !h ? s : () => !0
        }
      ),
      p !== "" && /* @__PURE__ */ l("div", { className: a([o["image-card__overlay-content"], "image-card__overlay-content"]), children: typeof p == "string" ? w(p) : p }),
      (e == null ? void 0 : e.type) === "play-video" && /* @__PURE__ */ i("button", { type: "button", onClick: s, className: a([o["image-card__play-icon"], "image-card__play-icon"]), children: [
        /* @__PURE__ */ l("span", { className: "sr-only", children: "PLAY BUTTON" }),
        /* @__PURE__ */ l("div", { className: `${o["play-icon__triangle"]}` })
      ] })
    ] }),
    n !== "" && /* @__PURE__ */ i("div", { className: a([o["image-card__content"], "image-card__content"]), children: [
      y !== "" && /* @__PURE__ */ l("h2", { className: "h4", children: y }),
      typeof n == "string" && /* @__PURE__ */ i("div", { children: [
        w(n),
        d && (e == null ? void 0 : e.type) && e.position === "inline" && u(e)
      ] }),
      typeof n != "string" && /* @__PURE__ */ i(v, { children: [
        n,
        d && (e == null ? void 0 : e.type) && e.position === "inline" && u(e)
      ] })
    ] }),
    d && (e == null ? void 0 : e.type) && (e == null ? void 0 : e.position) === "end" && /* @__PURE__ */ l("div", { className: o["image-card__cta-wrapper"], children: u(e) })
  ] });
});
export {
  G as default
};
